/**
 * WCD study types as they are stored in the database
 */
export enum WcdStudyTypes {
	MCOT = 'MCOT',
	WE = 'WE',
	HOLTER = 'Holter'
}
